import React from "react";
import { Card, Progress } from "antd";
import SelectOption from "components/select/SelectOption";
import EmployeeProfile from "components/card/EmployeeProfile";



const EmployeeProgressCard = ( props ) => {

  const { record, completed, total } = props;

  return (
          <Card className="flex flex-col rounded-2xl border-2 border-purple-200 gradient white">
            <div className="justify-between items-start flex flex-col md:flex-row md:items-center justify-between grid grid-cols-2">
              <EmployeeProfile
                record={record?.employee}
                nameInitialBg="!h-16 !w-16 border-2 border-purple-200 bg-text gradient-purple"
                empNameClass="text-[24px] font-semibold mb-1 title-text"
                empJobTitleClass="status-indicator normal bg-white"
                empIdClass="status-indicator normal bg-white mr-2"
                withEmpJobTitle={true}
                withDept={true}
                deptClass="text-[14px] muted-text mb-1"
              />


              <div className="flex space-x-3 items-end flex-col gap-2 w-full">
                <span className="text-gray-600 text-xs muted-text">Review Period</span>
                <div className="font-medium title-text">
                  {record?.type_name}
                </div>
              </div>
            </div>
            <div className="mt-6">
              <div className="flex items-center justify-between">
                <p className="text-[13px] font-medium muted-text">Review Progress</p>
                <p className="text-[13px] muted-text">{completed} / {total} categories completed</p>
              </div>
              <Progress
                percent={((Number(completed) || 0) / (Number(total) || 1)) * 100}
                showInfo={false} 
                strokeColor="#22c55e"
                trailColor="rgba(34, 197, 94, 0.2)"
                strokeWidth={8} 
                strokeLinecap="round"
              />
            </div>
          </Card>
);
};

export default EmployeeProgressCard;